import { useLocalize } from 'localize-react';
import React from 'react';

import airplaneSvg from '../airplane.svg';
import styles from './addFlightTrackingCard.module.scss';
import flightTracking from './flight-tracking.png';

export interface AddFlightTrackingCardProps {
  onAddFlightTracking: () => void;
}

export const AddFlightTrackingCard = ({ onAddFlightTracking }: AddFlightTrackingCardProps) => {
  const { translate } = useLocalize();

  return (
    <div className={styles['add-flight-tracking']}>
      <div className={styles.group}>
        <p className={styles.caption}>{translate('fn_AddFlightTracking_Tile')}</p>

        <img
          className={styles['flight-tracking']}
          alt="Flight tracking"
          src={flightTracking}
        />
      </div>

      <div className={styles.frame}>
        <p className={styles['text-wrapper']}>
          {translate('fn_AddFlightTracking_Body')}
        </p>
      </div>

      <button className={styles['buttons-elements']} onClick={() => onAddFlightTracking?.()}>
        <div className={styles.body}>
          <div className={styles['icon-l']}>
            <img src={airplaneSvg} alt="airplane icon" />
          </div>
          <div className={styles.div}>{translate('fn_AddFlightTracking_Button')}</div>
        </div>
      </button>
    </div>
  );
};
